export default __webpack_public_path__ + "static/media/banner3.4fef6c96.png";